import React from "react";
import BlockingTypesAdminCreate from "../../components/BlockingTypesAdminCreate/BlockingTypesAdminCreate";

function BlockingTypesAdminCreateContainer() {
  return (
    <div className="container_height">
      <BlockingTypesAdminCreate />
    </div>
  );
}

export default BlockingTypesAdminCreateContainer;
